import theme from 'assets/style/theme';
import { tableCellClasses } from '@mui/material/TableCell';
import tableSortLabelClasses from '@mui/material/TableSortLabel/tableSortLabelClasses';
import commonStyles from 'assets/style/commonStyles';

const messageCell = {
    maxWidth: '300px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-word',
};

const announcementStyle = {
    wrapper: {
        color: theme.palette.white,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
    },
    loadingStack: { width: '100%', height: 'calc(100vh - 100px)' },
    list: {
        wrapper: {
            color: theme.palette.white,
            flexGrow: 1,
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            // pt: 1.5,
            pb: 1,
        },
        headText: {
            font: theme.typography.fontSize.$font_heading_h5_medium,
            color: '#1E1E1E',
        },
        subscriptionCount: {
            fontSize: '16px',
            color: '#1E1E1E',
            paddingBottom: 1,
        },
        tableContainer: {
            marginTop: 0.5,
            borderRadius: '3px',
            boxShadow: '1px 1px 2px #00000014',
        },
        table: { marginTop: -1.125, borderSpacing: 0, minWidth: 900, height: 'auto' },
        styledTableSortLabel: {
            [`&.${tableSortLabelClasses.active}`]: {
                color: '#0A2756',
            },
            '&:hover': {
                color: '#0A2756',
            },
        },
        styledTableCell: {
            [`&.${tableCellClasses.head}`]: {
                backgroundColor: theme.palette.cyan['90'],
                color: theme.palette.blue.strongDark,
                font: theme.typography.fontSize.$font_small_bold,
                padding: 0,
                height: '50px',
                border: 0,
                '&:first-of-type': {
                    paddingLeft: '13px',
                },
                '&:not(:first-of-type)': {
                    paddingLeft: '13px',
                },
            },
            [`&.${tableCellClasses.body}`]: {
                font: theme.typography.fontSize.$font_xsmall_regular,
                color: '#1E1E1E',
                borderTop: '1px solid rgba(224, 224, 224, 1)',
                paddingTop: '12px',
                paddingBottom: '12px',
                paddingLeft: '13px',
                height: '50px',
            },
            '&:first-of-type': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
            },
            '&:last-child': {
                borderRight: '1px solid rgba(224, 224, 224, 1)',
            },
        },
        styledTableRow: {
            backgroundColor: '#FFFFFF',
            height: '50px',
            '&:nth-of-type(1) td': {
                height: '63px',
                paddingTop: '15px',
            },
            '&:last-child td, &:last-child th': {},
        },
        loadingRow: { background: 'transparent !important' },
        loadingCell: { border: '0 !important' },
        header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 1 },
        createBtn: { ...commonStyles?.primaryMediumButton, width: 'auto' },
        clickableRow: { cursor: 'pointer', '&:hover': { backgroundColor: '#F5F9FF' } },
        allText: { fontSize: '12px', color: '#757575' },
        catalogWrap: { display: 'flex', flexWrap: 'wrap', gap: 0.3 },
        catalogTooltipBox: {
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
            py: 0.5,
            maxHeight: '300px',
            overflowY: 'auto',
            '&::-webkit-scrollbar': { width: '6px' },
            '&::-webkit-scrollbar-thumb': { background: '#c8c8c8', borderRadius: '3px' },
        },
        catalogTooltipItem: { fontSize: '11px' },
        catalogTooltipProps: { backgroundColor: '#272727', fontSize: '11px', maxWidth: '300px' },
        catalogTooltipArrow: { color: '#272727' },
        messageCellSmall: { ...messageCell, fontSize: '12px' },
        titleCellSmall: {
            ...messageCell,
            maxWidth: '160px',
            fontSize: '12px',
        },
        actionIconBox: { cursor: 'pointer', display: 'flex', alignItems: 'center' },
        actionIconImg: { width: '18px', height: '18px' },
    },
    pagination: {
        tablePagination: {
            backgroundColor: '#FFFFFF',
            width: 'auto',
            color: '#1E1E1E',
            border: '1px solid #E0E0E0',
            '.MuiTablePagination-spacer': {
                flex: 0,
            },
            '.MuiToolbar-root': {
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row-reverse',
                alignItems: 'center',
            },
            '.MuiTablePagination-displayedRows': {
                fontWeight: 500,
                fontSize: '1rem',
                color: '#1E1E1E',
                paddingTop: '2px',
            },
        },
    },
    chip: {
        critical: { backgroundColor: '#FDEDED', color: '#D32F2F', fontWeight: 600, fontSize: '11px' },
        high: { backgroundColor: '#FFF4E5', color: '#ED6C02', fontWeight: 600, fontSize: '11px' },
        medium: { backgroundColor: '#E8F4FD', color: '#0288D1', fontWeight: 600, fontSize: '11px' },
        low: { backgroundColor: '#EDF7ED', color: '#2E7D32', fontWeight: 600, fontSize: '11px' },
        info: { backgroundColor: '#E3F2FD', color: '#1565C0', fontWeight: 600, fontSize: '11px' },
    },
    activeChip: {
        true: { backgroundColor: '#EDF7ED', color: '#2E7D32', fontWeight: 600, fontSize: '11px' },
        false: { backgroundColor: '#FDEDED', color: '#D32F2F', fontWeight: 600, fontSize: '11px' },
    },
    messageCell,
    catalogChip: {
        fontSize: '10px',
        height: '20px',
        margin: '2px',
        backgroundColor: '#F0F0F0',
        color: '#333',
    },
    actionIcon: {
        width: '18px',
        height: '18px',
        cursor: 'pointer',
    },
    form: {
        wrapper: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            overflow: 'auto',
            py: 2,
            color: '#1E1E1E',
        },
        heading: {
            font: theme.typography.fontSize.$font_heading_h5_medium,
            color: '#1E1E1E',
            marginBottom: 1,
        },
        formContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            maxWidth: '100%',
            backgroundColor: '#FFFFFF',
            borderRadius: '4px',
            padding: '24px',
            border: '1px solid #E0E0E0',
        },
        fieldWrapper: {
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            '& .quill': {
                '& .ql-editor': {
                    color: '#1E1E1E',
                    minHeight: '300px',
                },
                '& .ql-toolbar': {
                    borderColor: '#E0E0E0',
                },
                '& .ql-container': {
                    borderColor: '#E0E0E0',
                },
                '& .ql-container.ql-snow .ql-tooltip': {
                    zIndex: 1000,
                    left: '50% !important',
                    top: '50% !important',
                    transform: 'translate(-50%, -50%)',
                    whiteSpace: 'nowrap',
                },
            },
        },
        fieldLabel: {
            font: theme.typography.fontSize.$font_small_medium,
            color: '#1E1E1E',
        },
        actions: {
            display: 'flex',
            flexDirection: 'row',
            gap: '12px',
            marginTop: '8px',
        },
        cancelBtn: {
            textTransform: 'none',
            font: theme.typography.fontSize.$font_small_medium,
            color: '#0047BA',
            borderColor: '#0047BA',
            '&:hover': {
                borderColor: '#003399',
                backgroundColor: 'rgba(0, 71, 186, 0.04)',
            },
        },
        loadingWrapper: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' },
        catalogFieldRow: { display: 'flex', alignItems: 'center', gap: 1, width: '100%' },
        catalogSelect: { width: '100%', '& .MuiAutocomplete-clearIndicator': { marginTop: '-4px' } },
        selectedTag: { marginLeft: '10px' },
        activeRow: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 1 },
        activeLabel: { font: theme.typography.fontSize.$font_small_medium, color: '#0047BA', fontSize: '12px', fontWeight: '500' },
        messageLabel: (hasError) => ({
            font: theme.typography.fontSize.$font_small_medium,
            fontSize: '12px',
            fontWeight: '500',
            color: hasError ? '#d32f2f' : '#0047BA',
        }),
        quillEditor: (hasError) => ({
            background: '#fff',
            minHeight: '300px',
            border: hasError ? '1px solid #d32f2f' : undefined,
            borderRadius: hasError ? '3px' : undefined,
        }),
        errorText: { color: '#d32f2f', fontSize: '12px', mt: '3px', ml: '14px' },
        actionRow: { display: 'flex', justifyContent: 'flex-end', gap: '12px' },
    },
    detailModal: {
        fieldWrapper: { display: 'flex', flexDirection: 'column', gap: 0.5 },
        fieldLabel: { fontSize: '12px', fontWeight: 600, color: '#0047BA' },
        fieldValue: { fontSize: '13px', color: '#1E1E1E' },
        emptyValue: { fontSize: '13px', color: '#757575' },
        catalogList: { margin: 0, paddingLeft: '20px' },
        catalogListItem: { fontSize: '13px', color: '#1E1E1E' },
    },
};

export default announcementStyle;
